import { Roles } from '@utils/roles';
import { AppUser } from '../../domain';
import { Company } from '@modules/super-admin/company/domain/entities/company.entity';
import { ProfilePicture } from '@modules/regular-user/profile/domain';

export class AppUserModel implements AppUser {
  id: string = '';
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  roles: string[] = [];
  permissions: string[] | undefined;
  accountConfirmedAt?: Date | undefined;
  blocked: boolean = false;
  _companyId: string | null = null;
  company: Company | null = null;
  requiresPasswordChange: boolean = false;
  department?: string;
  companyName?: string;
  profilePicture?: ProfilePicture;
  _profilePicture?: string;
  jobTitle?: string;
  hasActiveSubscription: boolean = false;
  isSubscriptionBypassed: boolean = false;
  otpVerified: boolean = false;
  profileComplete: boolean = false;

  get isSuperAdmin(): boolean {
    if (this.roles?.length ?? 0 > 0) {
      let temp = this.roles!.filter((role: string) => {
        if (role == 'super-admin') {
          return true;
        } else {
          {
            return false;
          }
        }
      });

      if (temp.length > 0) return true;
      else return false;
    } else return false;
  }

  get isManager(): boolean {
    if (this.roles) {
      let temp = this.roles.filter(
        (role) => role == Roles.companyAdministrator
      );
      if (temp.length > 0) {
        return true;
      }
    }
    return false;
  }

  constructor(data: Partial<AppUser> & { _id?: string }) {
    this.id = data.id ?? data._id ?? this.id;
    this.email = data.email ?? this.email;
    this.firstName = data.firstName ?? this.firstName;
    this.lastName = data.lastName ?? this.lastName;
    this.roles = data.roles ?? this.roles;
    this.permissions = data.permissions ?? this.permissions;
    this.accountConfirmedAt =
      data.accountConfirmedAt ?? this.accountConfirmedAt;
    this.blocked = data.blocked ?? this.blocked;
    this._companyId = data._companyId ?? this._companyId;
    this.company = data.company ?? this.company;
    this.requiresPasswordChange =
      data.requiresPasswordChange ?? this.requiresPasswordChange;
    this.department = data.department ?? this.department;
    this.companyName = data.companyName ?? this.companyName;
    this.profilePicture = data.profilePicture ?? this.profilePicture;
    this._profilePicture = data._profilePicture ?? this._profilePicture;
    this.jobTitle = data.jobTitle ?? this.jobTitle;
    this.hasActiveSubscription =
      data.hasActiveSubscription ?? this.hasActiveSubscription ?? false;
    this.isSubscriptionBypassed =
      data.isSubscriptionBypassed ?? this.isSubscriptionBypassed ?? false;
    this.otpVerified = data.otpVerified ?? this.otpVerified;
    this.profileComplete = data.profileComplete ?? this.profileComplete;
  }

  copyWith(data: AppUser): AppUserModel {
    return new AppUserModel(Object.assign({}, this, data));
  }
}
